import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=574dace6&scoped=true&lang=pug"
import script from "./PaginationButton.vue?vue&type=script&lang=js"
export * from "./PaginationButton.vue?vue&type=script&lang=js"
import style0 from "./PaginationButton.vue?vue&type=style&index=0&id=574dace6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574dace6",
  null
  
)

export default component.exports